/**
 * Gift Progress Bar - Add to Cart Function
 * Loaded in theme head to ensure availability before cart drawer renders
 */
function addGiftToCart(variantId, productCard) {
  if (productCard.classList.contains('is-loading')) return;

  productCard.classList.add('is-loading');
  var btnText = productCard.querySelector('.gift-progress__add-btn-text');
  var btnLoading = productCard.querySelector('.gift-progress__add-btn-loading');
  if (btnText) btnText.style.display = 'none';
  if (btnLoading) btnLoading.style.display = 'inline-flex';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      items: [{ id: parseInt(variantId, 10), quantity: 1 }]
    })
  })
  .then(function(response) {
    if (!response.ok) throw new Error('Failed to add gift');
    return response.json();
  })
  .then(function() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  })
  .catch(function(error) {
    console.error('Gift add error:', error);
    productCard.classList.remove('is-loading');
    if (btnText) btnText.style.display = 'inline';
    if (btnLoading) btnLoading.style.display = 'none';
  });
}
